import { useMutation, useQueryClient } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { useNavigate } from 'react-router-dom'
import { routes } from '@/router'
import { clearStoragePreservingAnnouncements } from '@/helpers'

export async function logout() {
  const response = await httpClient('user-manager').post('/v1/user/me/logout')

  return response.data
}

export function useLogout() {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      clearStoragePreservingAnnouncements()
      sessionStorage.clear()
      queryClient.clear()
      navigate(routes.session.signin)
    },
  })
}
